<template>
  <b-form @submit.prevent="state === 'STEP1' ? sendCode() : submit()">
    <b-row class="margin-0 overflow-hidden position-relative">
      <b-col
        l
        key="one"
        v-if="state === 'STEP1'"
        cols="12"
        class="padding-0 margin-bottom-24"
      >
        <Alert
          :text="$lang.change_mobile_alert_message"
          variant="light-warning"
        />
      </b-col>
      <b-col
        key="two"
        v-if="state === 'STEP1'"
        cols="12"
        class="padding-0 position-relative"
      >
        <!-- created element username input just for remove browser suggestion username -->
        <input type="username" class="d-none" />
        <Input
          :title="$lang.new_mobile"
          :label="$lang.new_mobile"
          :placeholder="$lang.new_mobile"
          :value="form.mobile"
          name="mobile"
          id="mobile"
          type="text"
          :minLength="lengthNumber11"
          :maxLength="lengthNumber11"
          :vuelidateObj="$v.form.mobile"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
      </b-col>
      <b-col
        key="three"
        v-if="state === 'STEP2'"
        cols="12"
        class="padding-0 position-relative"
      >
        <Otp
          :value="form.code"
          name="code"
          id="code"
          :vuelidateObj="$v.form.code"
          :expireSeconds="expireSeconds"
          :showEdit="true"
          @input="input"
          @resend="setState('STEP1')"
          @editNumber="setState('STEP1')"
          @onComplete="submit"
        />
      </b-col>
      <b-col cols="12" class="flex-end padding-0 margin-top-2">
        <Button
          contentClass="justify-content-center"
          variant="filled-complementary"
          :text="$lang.cancel"
          @click="close()"
        />
        <Button
          class="margin-right-8"
          contentClass="justify-content-center"
          variant="filled-primary"
          type="submit"
          :text="state === 'STEP1' ? $lang.continue : $lang.submit"
          :loading="loading"
        />
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import Alert from "@/components/re-design/alert/Alert.vue";
import Otp from "@/components/re-design/otp/Otp.vue";
import { Input, Button } from "@/components/re-design/forms";
import {
  required,
  requiredIf,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { checkPersianCharValidation } from "@/shared/utils";
import { changeUserMobile } from "@/modules/profile/services";
import { generateOtpCode } from "@/services";
import { computed } from "vue";

export default {
  mixins: [inputMixin],
  components: { Alert, Otp, Input, Button },
  provide() {
    // provide this data to all deep child components
    return {
      MOBILE: computed(() => this.form.mobile),
      EXPIRE_SECONDS: computed(() => this.expireSeconds),
    };
  },
  props: {
    userData: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        mobile: {
          required,
          numeric,
          persianCharacters: (val) => !checkPersianCharValidation(val),
          minLength: minLength(this.lengthNumber11),
          maxLength: maxLength(this.lengthNumber11),
        },
        code: {
          required: requiredIf(() => this.state === "STEP2"),
          numeric,
          minLength: minLength(this.codeLength),
        },
      },
    };
  },
  data() {
    return {
      form: {
        mobile: null,
        code: null,
      },
      loading: false,
      state: "STEP1",
      controlCode: null,
      expireSeconds: null,
    };
  },
  watch: {
    state: {
      immediate: true,
      handler() {
        this.updateTitle();
      },
    },
  },
  methods: {
    pathOr,
    close() {
      this.$emit("close");
    },
    reload() {
      this.$emit("reload");
    },
    updateTitle() {
      const title =
        this.state === "STEP1"
          ? this.$lang.change_mobile
          : this.$lang.confirm_mobile;
      this.$emit("getTitle", title);
    },
    setState(state) {
      this.state = state;
    },
    async sendCode() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loading = true;
        const mode = "change_mobile";
        const response = await generateOtpCode(mode, this.form.mobile);
        const { controlCode, resExpireSeconds } = response;
        this.controlCode = controlCode;
        this.expireSeconds = resExpireSeconds;
        this.setState("STEP2");
        this.$v.$reset();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loading = true;
        const { mobile, code } = this.form;
        const response = await changeUserMobile(mobile, code, this.controlCode);
        const { message } = response;
        this.$notify.success(message);
        this.close();
        this.reload();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
